// @flow @jsx h
import { h } from 'preact'
import { PureComponent } from '../../lib/pureComponent'
import styles from './App.css'
import { connect } from '../../lib/provider'
import { findMostOccurrences } from '../../lib/findMostOccurrences'
import { Questions } from './Questions'
import { Result } from './Result'
import type { Quiz, UserAnswersProps } from '../types'

type Props = {
  sendGaEvent: Object => void,
  quizData: Quiz,
  dynamicEsiRenderBaseUrl: string,
  shareHost: string,
  shareConfig: string
}

type State = {
  userAnswers: UserAnswersProps
}

const initialState = {
  userAnswers: []
}

class _App extends PureComponent<Props, State> {
  state = { ...initialState }

  onAnswerClick = (sampleName: Array<string>, questionId: string, id: string): void => {
    const { userAnswers } = this.state
    const { sendGaEvent, quizData } = this.props
    let clonedUserAnswers = userAnswers.slice(0)
    const answeredQuestionIndex = clonedUserAnswers.findIndex(userAnswer => userAnswer.questionId === questionId)
    if (!(answeredQuestionIndex > -1)) {
      clonedUserAnswers = clonedUserAnswers.concat({
        sampleName,
        questionId,
        id
      })
    } else {
      clonedUserAnswers[answeredQuestionIndex].sampleName = sampleName
      clonedUserAnswers[answeredQuestionIndex].id = id
    }
    this.setState({
      userAnswers: clonedUserAnswers
    })
    const questionObj = quizData.questions.find(question => question.id === questionId)
    if (typeof questionObj !== 'undefined') {
      const answerObj = questionObj.answers.find(answer => answer.id === id)
      sendGaEvent({
        label: questionObj.questionTitle,
        action: `${answerObj ? answerObj.answerText : ''}`
      })
    }
  }

  getResultSample() {
    const { quizData, sendGaEvent } = this.props
    const { samples, questions } = quizData
    const { userAnswers } = this.state
    const userAnswerArray = userAnswers.map(userAnswer => userAnswer.sampleName)
    const flatUserAnswerArray = userAnswerArray.reduce((acc, val) => acc.concat(val), [])
    if (userAnswerArray.length === questions.length) {
      const sample = samples.find(sample => sample.name === findMostOccurrences(flatUserAnswerArray))
      sendGaEvent({
        label: 'Resultat',
        action: sample ? sample.name : ''
      })
      return sample
    }
    return {}
  }

  render() {
    const { userAnswers } = this.state
    const { quizData, dynamicEsiRenderBaseUrl, shareHost, shareConfig } = this.props
    return (
      <div class={`${styles['personalityquiz']}`}>
        <Questions onAnswerClick={this.onAnswerClick} quizData={quizData} userAnswers={userAnswers} />
        <Result
          isFinished={userAnswers.length === quizData.questions.length}
          resultSample={this.getResultSample()}
          dynamicBaseUrl={dynamicEsiRenderBaseUrl}
          shareHost={shareHost}
          shareConfig={shareConfig}
          resultText={quizData.resultText}
        />
      </div>
    )
  }
}

const connector = connect()
export const App = connector(_App)



// WEBPACK FOOTER //
// ./src/v1/components/App.js